import { useEffect } from 'react';
import tw from 'twin.macro';

import { Layout } from '@insights_module/components/Layout';
import { Header as IntegrationHeader } from '@insights_module/components/integrations/Header';
import { TagsList } from '@insights_module/components/integrations/TagsList';
import { CreateTagModal } from '@insights_module/components/integrations/CreateTagModal';
import { DeleteTagModal } from '@insights_module/components/integrations/DeleteTagModal';
import { ViewTagModal } from '@insights_module/components/integrations/ViewTagModal';
import { INTEGRATION_TYPE } from '@insights_module/constants/integrations';
import { useSegmentCreatorContext } from '@insights_module/context/SegmentCreatorContext';
import { EditTagDescriptionModal } from '@insights_module/components/integrations/EditTagDescriptionModal';
import { withTitle } from '@hoc/withTitle';

const ContentWrapper = tw.div`h-full w-full`;

const _MegaphoneIntegrationPage = (): JSX.Element => {
  const { setQueryType } = useSegmentCreatorContext();

  useEffect(() => {
    setQueryType('audio');
  }, []);

  return (
    <Layout.InsightsPage>
      <ContentWrapper>
        <IntegrationHeader type={INTEGRATION_TYPE.MEGAPHONE} />
        <TagsList type={INTEGRATION_TYPE.MEGAPHONE} />

        <CreateTagModal type={INTEGRATION_TYPE.MEGAPHONE} />
        <DeleteTagModal type={INTEGRATION_TYPE.MEGAPHONE} />
        <ViewTagModal type={INTEGRATION_TYPE.MEGAPHONE} />
        <EditTagDescriptionModal type={INTEGRATION_TYPE.MEGAPHONE} />
      </ContentWrapper>
    </Layout.InsightsPage>
  );
};

export const MegaphoneIntegrationPage = withTitle(
  _MegaphoneIntegrationPage,
  'insights.integrations.title'
);
